import * as React from "react";
import { connect } from "react-redux";

import { IServer, IState } from "../../classes/state";

import { SelectEventsModal } from "./SelectEventsModal";

import * as calendarSettingsActions from "../../actions/calendarSettingsActions";
import * as selectEventsActions from "../../actions/selectEventsFromOtherCalendarsActions";

export class SelectEventsModalContainer extends React.Component<any, any> {

  public constructor(props: any, context: any) {
    super(props, context);
  }

  public render() {
    return (
      <div>

        <SelectEventsModal
          calendarId={this.props.calendarId}
          childServerIds={this.props.childServerIds}
          currentServerId={this.props.currentServerId}
          displayModal={this.props.displayModal}
          numAjaxCallsInProgress={this.props.numAjaxCallsInProgress}
          parentServerId={this.props.parentServerId}
          portletInstanceId={this.props.portletInstanceId}
          rootServerId={this.props.rootServerId}
          servers={this.props.servers}
          checkedNodeItemIds={this.props.checkedNodeItemIds}
          checkedNodeCalendarIds={this.props.checkedNodeCalendarIds}
          expandedNodeItemIds={this.props.expandedNodeItemIds}
          text={this.props.text}
          currentPageNumber={this.props.pager_currentPageNumber}
          onCloseModal={this.props.onCloseModal}
          updateCheckedNodeItemIds={this.props.updateCheckedNodeItemIds}
          updateCheckedNodeCalendarIds={this.props.updateCheckedNodeCalendarIds}
          updateExpandedNodeItemIds={this.props.updateExpandedNodeItemIds}
          updateServersSitesPagesAndCalendars={this.props.updateServersSitesPagesAndCalendars}
          updateCurrentPageNumber={this.props.updateCurrentPageNumber}
        />
      </div>
    );
  }

}

const mapStateToProps = (state: IState, ownProps: any) => { // 'state' is the state in our Redux Store; 'ownProps' is a reference to this component's own this.props.
  return {
    calendarId: state.calendarSettings.calendarId,
    checkedNodeCalendarIds: state.selectEventsFromOtherCalendarsSettings.checkedNodeCalendarIds,
    checkedNodeItemIds: state.selectEventsFromOtherCalendarsSettings.checkedNodeItemIds,
    childServerIds: state.selectEventsFromOtherCalendarsSettings.childServerIds,
    currentServerId: state.selectEventsFromOtherCalendarsSettings.currentServerId,
    displayModal: state.selectEventsFromOtherCalendarsSettings.openSelectEventsFromOtherCalendarsModal,
    expandedNodeItemIds: state.selectEventsFromOtherCalendarsSettings.expandedNodeItemIds,
    numAjaxCallsInProgress: state.numAjaxCallsInProgress,
    pager_currentPageNumber: state.selectEventsFromOtherCalendarsSettings.pager_currentPageNumber,
    parentServerId: state.selectEventsFromOtherCalendarsSettings.parentServerId,
    portletInstanceId: state.calendarSettings.portletInstanceId,
    rootServerId: state.selectEventsFromOtherCalendarsSettings.rootServerId,
    servers: state.selectEventsFromOtherCalendarsSettings.servers,
    text: state.text,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    onCloseModal: () => {
      dispatch(selectEventsActions.setOpenSelectEventsFromOtherCalendarsModal(false));
    },
    updateCheckedNodeCalendarIds: (checkedNodeCalendarIds: string[]) => {
      dispatch(selectEventsActions.updateCheckedNodeCalendarIds(checkedNodeCalendarIds));
    },
    updateCheckedNodeItemIds: (checkedNodeItemIds: string[]) => {
      dispatch(selectEventsActions.updateCheckedNodeItemIds(checkedNodeItemIds));
    },
    updateCurrentPageNumber: (pageNumber: number) => {
      dispatch(selectEventsActions.updateCurrentPageNumber(pageNumber));
    },
    updateExpandedNodeItemIds: (expandedNodeItemIds: string[]) => {
      dispatch(selectEventsActions.updateExpandedNodeItemIds(expandedNodeItemIds));
    },
    updateServersSitesPagesAndCalendars: (servers: IServer[]) => {
      dispatch(selectEventsActions.updateServersSitesPagesAndCalendars(servers));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectEventsModalContainer);
